import { Component, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { QuestionService } from '../../services/question.service';
import { bootstrapJournalBookmark, bootstrapJournalBookmarkFill } from '@ng-icons/bootstrap-icons';
import { ActionDropdownComponent } from '../action-dropdown/action-dropdown.component';
import { AnswerOption, Evaluation, Question } from '../../interfaces/questionInterface';
import { AnswerItemComponent } from './answer-item/answer-item.component';

@Component({
    selector: 'app-answer',
    imports: [NgIconComponent, ActionDropdownComponent, AnswerItemComponent],
    templateUrl: './answer.component.html',
    styleUrl: './answer.component.scss',
    providers: [provideIcons({ bootstrapJournalBookmark, bootstrapJournalBookmarkFill })]
})
export class AnswerComponent implements OnInit, OnChanges {
  @Input() question: Question | undefined;
  @Input() flagged: boolean = false;
  @Input() showFlag: boolean = true;
  @Input() index: number = 0;
  @Input() total: number = 0;

  @Input()
  set bookmarked(bookmarked: boolean){
    // if this is given, component doesnt query itself whether the question is bookmarked
    // should be used when there are more than one AnswerComponents on the same page to avoid
    // making many API calls
    this._bookmarked = bookmarked;
  }

  _bookmarked: boolean | undefined = undefined;

  @Input() evaluation: Evaluation | undefined;
  @Input() neutralFeedback: boolean = false;
  
  @Input() bookmarkInfo: undefined | {responseId: string, courseId?: string}

  @Input() orderSeed?: string;

  public correct: 'none' | 'some' | 'all' | undefined = 'all';
  correctCount: number = 0;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private questionService: QuestionService
  ) { }

  ngOnInit(): void {
    if(this._bookmarked === undefined && this.question){
      this.questionService.isQuestionBookmarked(this.question.id).then((bookmarked) => {
        this._bookmarked = bookmarked;
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question']?.currentValue) {
      if(this.orderSeed){
        changes['question'].currentValue = this.questionService.shuffleAnswerOptions(changes['question'].currentValue, this.orderSeed)
      }
      this.correctCount = changes['question'].currentValue.expand.answer_options?.filter((a: AnswerOption) => a.correct).length || 0;
    }

    if (changes['evaluation'] && changes['evaluation'].currentValue) {
      const evaluation = changes['evaluation'].currentValue as Evaluation;
      if (evaluation.every(e => e.hit)) {
        this.correct = 'all';
      } else if (evaluation.some(e => e.hit && e.correct)) {
        this.correct = 'some';
      } else {
        this.correct = 'none';
      }
    }
  }

  //needed for EvaluationComponent to display only what should be there (filter)
  public show(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'block');
  }

  //needed for EvaluationComponent to hide what shouldn't be there (filter)
  public hide(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
  }

  async toggleBookmarked() {
    if (this.question && this.bookmarkInfo) {
      if (this._bookmarked) {
        await this.questionService.unBookmarkQuestion(this.question.id);
      } else {
        await this.questionService.bookmarkQuestion(this.bookmarkInfo.responseId, this.bookmarkInfo.courseId);
      }
      this._bookmarked = !this._bookmarked;
    }
  }

  getEvaluation(answerOptionId: string): AnswerOption & { hit: boolean; }{
    const evaluation = this.evaluation?.find(evaluation => evaluation.id === answerOptionId)
    
    if(!evaluation){
      throw new Error();
    }

    return evaluation;
  }
}
